import { action as apiAction } from 'api/Api'
import {
  addCardRelation
} from 'store/redux/cardRelations'
import {
  addItem as addItemToElement
} from '../redux/elements'
import {
  add as addSubCard
} from '../redux/subCards'
import sweetalert from 'sweetalert2'
import { optimisticDispatch } from 'utils/sagas'

const findChild = (id, cardRelationsById, childId) => {
  let child = null

  if (!cardRelationsById[id]) return null

  const childIds = cardRelationsById[id].childIds

  let i
  const length = childIds.length
  for (i = 0; i < length; i++) {
    if (childIds[i] === childId) {
      child = childId
      break
    }

    const _child = findChild(childIds[i], cardRelationsById, childId)

    if (_child) {
      child = _child
      break
    }
  }

  return child
}

async function displayCycleError (state) {
  try {
    await sweetalert({
      text: state.kanbo.locale.messages['CARD_RELATION_PARENT_CHILD_CYCLE_ERROR'],
      type: 'info'
    })
  } catch (e) {}
}

async function displayDuplicateSubcardAlert (state) {
  try {
    await sweetalert({
      text: state.kanbo.locale.messages['SUBCARD_ADD_DUPLICATE'],
      type: 'info'
    })
  }
  catch (e) {}
}

type Payload = {
  cardId: number
  subCardId: number
  subCardGroupId: number
}

export default (payload: Payload) => async (dispatch, getState) => {
  const { cardId, subCardId, subCardGroupId } = payload

  const state = getState()

  const cardRelationsById = state.kanbo.cardRelations.byId

  if (findChild(subCardId, cardRelationsById, cardId)) {
    await displayCycleError(state)

    return
  }

  const tempId = `temp-${new Date().getTime()}`

  const optimisticAction = optimisticDispatch(dispatch, [
    addCardRelation({
      id: cardId,
      childIds: [subCardId]
    }),
    addCardRelation({
      id: subCardId,
      parentIds: [cardId],
    }),
    addSubCard({
      cardId,
      subCard: {
        id: tempId,
        subCardId,
      }
    }),
    addItemToElement({
      elementId: subCardGroupId,
      itemId: tempId,
      index: undefined
    })
  ])

  try {
    await apiAction('AddCardParent', {
      cardId: subCardId,
      cardParentId: cardId,
      target: {
        groupId: subCardGroupId
      }
    })
  } catch (error) {
    if (error.code === 1102) { // Cycle
      await displayCycleError(getState())
    } else if (error.code === 1100) { // CardRelationExistsException
      await displayDuplicateSubcardAlert(getState())
    } else if (error.code === 506) { // Card is archived
      const state = getState()

      try {
        await sweetalert({
          text: state.kanbo.locale.messages['SUBCARD_ADD_ARCHIVED_CARD'],
          type: 'info'
        })
      } catch (e) {}
    } else if (
      error.code !== 1101 && // CardHasParentEqualException
      error.code !== 1103 // CardRelationCannotPointAtItselfException
    ) {
      throw error
    }
  } finally {
    optimisticAction.revert()
  }
}
